__turbopack_context__.v({
  "chip": "Chip-module-scss-module__sF7A7W__chip",
  "chip-delete-icon": "Chip-module-scss-module__sF7A7W__chip-delete-icon",
  "chip-icon": "Chip-module-scss-module__sF7A7W__chip-icon",
  "chip-text": "Chip-module-scss-module__sF7A7W__chip-text",
  "content-container": "Chip-module-scss-module__sF7A7W__content-container",
});
